<template>
  <div class="pdfDemo">
    <section id="pdf" ref="print" style="width: 100%">
      <pdf class="form"></pdf>
    </section>
    <div style="padding: 30px 0">
      <router-link class="editor" to="/form">编辑</router-link>
      <button class="btn" @click="print">下载文件</button>
      <router-link class="back" to="/index">返回首页</router-link>
    </div>
  </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import pdf from './pdfTmp'
export default {
  components: {
    pdf
  },
  data () {
    return {

    };
  },

  methods: {
    print () {
      this.$print(this.$refs.print);
    },
  },
}
</script>
<style scoped>
@media print {
  .pdfDemo .form {
    transform-origin: 50% 0 !important;
    transform: scale(1.2) !important;
    font-stretch: normal !important;
    margin: 0 auto !important;
    font-family: "宋体" !important;
    padding-bottom: 0 !important;
  }
}
.pdfDemo {
  text-align: center;
  padding-top: 20px;
  font-family: "宋体";
}
.pdfDemo .editor {
  display: inline-block;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
  width: 166px;
  height: 35px;
  border-radius: 4px;
  background: rgba(24, 144, 255, 1);
  margin-right: 20px;
}
.pdfDemo .btn {
  border: none;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
  width: 166px;
  height: 35px;
  border-radius: 4px;
  background: rgba(24, 144, 255, 1);
  /*background: rgba(24, 144, 255, 1) url(../../static/img/up.png) no-repeat 13px 10px;
			background-size: 14px 14px;*/
}
.pdfDemo .back {
  display: inline-block;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
  width: 166px;
  height: 35px;
  border-radius: 4px;
  background: rgba(24, 144, 255, 1);
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Table.vue